import { useDispatch, useSelector } from "react-redux";

import { CreateEvent } from "../../redux/events";
import { ErrorBanner } from "../../components/banner";
import { EventForm } from "./EventForm";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const EventCreate = () => {
  const dispatch = useDispatch();
  const { error, loading } = useSelector((state) => state.events);
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to add this article`)) {
      const address = {
        street: values.street || " ",
        city: values.city || " ",
        state: values.state || " ",
        zipcode: values.zipcode || " ",
      };

      const newValues = {
        ...values,
        description: values.description || " ",
        address,
      };

      dispatch(CreateEvent(newValues));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/events");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      {error && <ErrorBanner text={error} />}

      <EventForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
